import Video from '@components/Video';
import { useStoreState } from 'easy-peasy';
import PropTypes from 'prop-types';
import { jobStoreSelector } from '@model/Job/Job.selectors';

export const SuccessFeeSidebar = ({ candidateName }) => {
  const job = useStoreState(jobStoreSelector);

  return (
    <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-4">
      <div className="o-sidebar o-sidebar--y-antipodes">
        <div>
          <p className="rev-o-typo-primary-level-3 rev-u-typo-w-primary-medium rev-u-lh-copy rev-u-color-grey-60">
            {job.title}
          </p>
          <p className="rev-o-typo-heading-5 rev-u-mt-8 rev-u-mb-32">
            {candidateName}
          </p>
        </div>

        <Video
          video="pyramids"
          sources={['webm']}
          modifier="c-video--success-fee u-hidden-medium-down"
        />
      </div>
    </div>
  );
};

SuccessFeeSidebar.propTypes = {
  candidateName: PropTypes.string.isRequired,
};
